import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectDto } from '@api/projects/interfaces';
import { projectPages } from '@app/pages/project/projects.routes';
import { PermissionService } from '@app/services/permission/permission.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectService } from '../../../../../services/project/project.service';
import { ProtectedPrivacyService } from '../../../../../services/ui/protected-privacy.service';

@Component({
	selector: 'app-topbar-project-management',
	templateUrl: './project-management.component.html',
	styleUrls: ['./project-management.component.scss'],
})
export class TopbarProjectManagementComponent {
	public showOverview$: Observable<boolean>;
	public showSelector$: Observable<boolean>;
	public activeProject$: Observable<ProjectDto>;
	public projects$: Observable<ProjectDto[]>;

	constructor(
		private projectService: ProjectService,
		private router: Router,
		privacyService: ProtectedPrivacyService,
		permissionService: PermissionService,
	) {
		this.activeProject$ = projectService.activeProject$;
		this.projects$ = projectService.projects$;

		this.showOverview$ = permissionService.permissions$.pipe(
			map(permissions => !!permissions?.includes('projects:read')),
		);
		this.showSelector$ = privacyService.toggleChange$().pipe(
			map(privacyMode => !privacyMode),
		);
	}

	changeProject(project: ProjectDto): void {
		this.projectService.setActiveProject(project);
	}

	showOverview(): void {
		this.router.navigate([projectPages.dashboard.base()]);
	}
}
